import styles from "./RouteLoading.module.css";

/** Suspense fallback shown briefly while a lazy-loaded route's chunk downloads. */
export default function RouteLoading() {
  return (
    <div className={styles.center} role="status" aria-live="polite">
      <div className={styles.spinner} />
    </div>
  );
}
